import type { WaitingKind } from "../../game/types";
import { useController, useGame } from "../context";

const TITLES: Record<WaitingKind, string> = {
  peer: "Ожидаем второго игрока…",
  filters: "Ждём фильтры второго игрока…",
  opponent: "Вы посмотрели все фильмы. Ждём второго участника…",
  restart: "Начинаем заново…",
};

export function WaitingScreen() {
  const controller = useController();
  const waiting = useGame((s) => s.waiting);
  const progress = useGame((s) => s.otherProgress);
  const peerOnline = useGame((s) => s.peerOnline);

  const finished = waiting === "opponent" && progress !== null && progress.index >= progress.total;
  const percent =
    progress && progress.total > 0 ? Math.round((progress.index / progress.total) * 100) : 0;

  return (
    <section className="screen screen--centered">
      <h3>{finished ? "Второй участник закончил просмотр" : TITLES[waiting]}</h3>
      {waiting === "opponent" && progress && (
        <p className="note">
          Второй участник: {progress.index} / {progress.total} ({percent}%)
        </p>
      )}
      {waiting !== "peer" && waiting !== "restart" && !peerOnline && (
        <p className="note">Второй участник не в сети — ждём, пока вернётся</p>
      )}
      <button type="button" className="btn" onClick={() => controller.goHome()}>
        Выйти
      </button>
    </section>
  );
}
